import React from "react";
import { Link } from "react-router-dom";

const SuccessPage = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1>Payment Successful ✅</h1>
      <p>Thank you for booking the workshop.</p>
      <Link to="/workshops">Back to workshops</Link>
    </div>
  );
};

export default SuccessPage;
